<template>
  <a
    :href="link ? link : false"
    class="s-document"
    rel="noopener noreferrer"
    target="_blank"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'SDocument',
  props: {
    link: {
      type: String,
      default: '',
      required: true
    }
  }
}
</script>

<style lang="scss">
.s-document {
  max-width: 766px;
  display: inline-flex;
  padding-left: 24px;
  background-image: url('~@/assets/icons/common/document.svg?inline');
  background-position-y: 4px;
  background-repeat: no-repeat;
  background-size: 16px;

  @media (max-width: $breakpoint-md) {
    background-position-y: 2px;
  }
}

.s-document:hover {
  color: $secondaryDark;
}
</style>